import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Eye, EyeOff } from "lucide-react";
import { toast } from "react-toastify";
import BASE_URL from "./apibaseurl/ApiBaseUrl";


export default function Signin() {

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [redirectUrl, setRedirectUrl] = useState("");
  const [Email, setEmail] = useState("");
  const [userId, setUserId] = useState("");



  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  useEffect(() => {
    const storedUserData = localStorage.getItem("userData");
    if (storedUserData) {
      try {
        const userData = JSON.parse(storedUserData);
        if (userData.is_user_login === true || userData.is_admin_login === "true") {
          setIsLoggedIn(true);
          setRedirectUrl(userData.redirect_url);
          setEmail(userData.email);
          if(userData.admin_id) {
            setUserId(userData.admin_id);
          }else{
            setUserId(userData.user_id);
          }
        }
      } catch (e) {
        console.error("Invalid userData in localStorage");
      }
    }
  }, []);


  const validate = () => {
    const newErrors: { [key: string]: string } = {};
    if (!formData.email) newErrors.email = "Email or Username is required";
    if (!formData.password) newErrors.password = "Password is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validate()) return;

    const form = new FormData();
    form.append("email", formData.email);
    form.append("password", formData.password);

    try {
      const response = await fetch(`${BASE_URL}/login`, {
        method: "POST",
        body: form,
      });

      const data = await response.json();
      if (data?.status === 1) {
        setIsLoggedIn(true);
        localStorage.setItem("userData", JSON.stringify(data?.data || data?.user || {}));

        const loginRedirectUrl = data.data?.redirect_url || "";
        const loginEmail = data.data?.email || formData.email;
        const loginUserId = data.data?.user_id || data.data?.admin_id || "";
        const redirect_url = `${loginRedirectUrl}?is_web_login=1&email=${loginEmail}&user_id=${loginUserId}`
        toast.success("Login successful!");
        window.location.href = redirect_url;
      } else {
        toast.error(data?.message || "Login failed");
      }
    } catch (error) {
      toast.error("Something went wrong");
    }
  };

  return (
    <div className="h-screen:h-[calc(100vh-79px)] flex flex-col bg-white">
      {/* Centered Content */}
      <div className="flex-grow flex items-center">
        <div className="lg:mx-20 mx-3 grid grid-cols-1 md:grid-cols-2 items-center px-6 py-16 gap-10 w-full">
          {/* Left Form Section */}
          <div className="space-y-6 lg:mx-[60px]">
            <h2 className="text-[40px] lg:text-5xl text-[#234042] Bebas-neue">LOG IN</h2>
            <p className="text-lg lg:text-lg  text-[#F47321] uppercase Bebas-neue tracking-light" >
              Please sign-in to your account
            </p>

            <div className="grid grid-cols-1 gap-4">
              <div>
                <label htmlFor="email" className="text-sm block mb-1 helvetica-neue  text-[#666666]">
                  Email or Username
                </label>
                <input
                  id="email"
                  name="email"
                  type="text"
                  value={formData.email}
                  onChange={handleChange}
                  className={`rounded-none text-black !text-sm helvetica-neue   py-3 px-3 w-full  bg-white border ${errors.email ? "border-red-500" : "border-[#666666]"
                    }`}
                />
                {errors.email && <p className="text-red-500 !text-xs mt-1 helvetica-neue">{errors.email}</p>}
              </div>
              <div>
                <label htmlFor="password" className="text-sm block mb-1 helvetica-neue text-[#666666]">
                  Password
                </label>
                <div className="relative w-full ">
                  <input
                    id="password"
                    name="password"
                    type={showPassword ? "text" : "password"}
                    value={formData.password}
                    onChange={handleChange}
                    className={`rounded-none py-3 px-3 text-black !text-sm helvetica-neue w-full bg-white border ${errors.password ? "border-red-500" : "border-[#666666]"
                      } pr-10`}
                  />
                  <span
                    className="absolute top-4 right-3 cursor-pointer text-gray-600"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                  </span>
                </div>
                {errors.password && <p className="text-red-500 !text-xs mt-1 helvetica-neue">{errors.password}</p>}
              </div>
            </div>

            <div className="flex items-center space-x-2">
              <input type="checkbox" id="remember" className="bg-white" />
              <label htmlFor="remember" className="text-xs lg:text-[18px]  helvetica-neue text-black helvetica-neue">
                Remember me
              </label>
            </div>

            <button
              type="submit"
              onClick={handleSubmit}
              className="bg-[#F47321] uppercase hover:bg-[#F47321] text-white rounded-none 
                        transition transform scale-y-125 text-xs lg:text-[15px] font-normal lg:px-4 lg:py-3 px-2 py-2 
                         flex items-center gap-2 btn-hover-effect"
            >

              <span> SIGN IN</span>
              <span className="icon-arrow-right">
                <ArrowRight className="w-3 h-3 sm:w-4 sm:h-4" />
              </span>
            </button>
          </div>

          {/* Right Image Section */}
          <div className="block">
            <img
              src="/images/login.png"
              alt="signin illustration"
              className="w-full "
            />
          </div>
        </div>
      </div>

      {/* Bottom Sign In - stays at bottom */}
      <div className="bg-[#156E77] text-white text-center py-4">
        <div className="lg:mx-[150px] mx-4 px-4 flex flex-row justify-between items-center">
          <p className="!text-lg lg:!text-lg mb-0 lg:mb-2 !font-normal helvetica-neue ">New User?</p>
          <Link to="/signup">
            <button
              className="bg-white text-black rounded-none 
                        transition transform scale-y-125 text-xs lg:text-[15px] font-normal lg:px-4 lg:py-2 px-2 py-2 
                         uppercase flex items-center gap-2 btn-hover-white"
            >

              <span>Create an Account</span>
              <span className="icon-arrow-right">
                <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5" />

              </span>
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
}
